"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageBannerComponent = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var icon_1 = require("../icon");
var icons_1 = require("../icon/icons");
var mithril_component_1 = require("../mithril.component");
var message_banner_style_1 = require("./message.banner.style");
var MessageBannerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MessageBannerComponent, _super);
    function MessageBannerComponent() {
        var _this = _super.call(this) || this;
        _this.name = 'MessageBanner';
        _this.bannerVisible = false;
        return _this;
    }
    Object.defineProperty(MessageBannerComponent.prototype, "nodes", {
        get: function () {
            var _this = this;
            if (this.bannerVisible) {
                return (0, mithril_1.m)('div', { className: message_banner_style_1.CSS.alert }, [
                    (0, mithril_1.m)('span', { className: message_banner_style_1.CSS.message }, [
                        (0, i18n_1.Translate)(i18n_1.T.BANNER_MESSAGE_PT1),
                        (0, mithril_1.m)('a', { className: message_banner_style_1.CSS.alertHref, href: 'https://ikegps.com/support/sso-for-ike/', target: '_blank' }, (0, i18n_1.Translate)(i18n_1.T.HERE)),
                        (0, i18n_1.Translate)(i18n_1.T.BANNER_MESSAGE_PT2)
                    ]),
                    (0, mithril_1.m)('button', {
                        className: message_banner_style_1.CSS.closeButton,
                        onclick: function () { _this.bannerVisible = false; },
                        title: i18n_1.T.CLOSE
                    }, [
                        (0, i18n_1.Translate)(i18n_1.T.DISMISS),
                        icon_1.Icon.view(icons_1.MaterialIcon.CLOSE, {
                            className: message_banner_style_1.CSS.closeIcon
                        })
                    ])
                ]);
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], MessageBannerComponent.prototype, "bannerVisible", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], MessageBannerComponent.prototype, "nodes", null);
    return MessageBannerComponent;
}(mithril_component_1.IMithrilComponent));
exports.MessageBannerComponent = MessageBannerComponent;
//# sourceMappingURL=message.banner.js.map